import React from 'react';
import svgPaths from "../../../pages/interface/imports/svg-gbfq0i2mna";

// Jira Icon Component - Official Atlassian Jira Logo
export const JiraIcon: React.FC<{ width?: number; height?: number }> = ({ width = 20, height = 20 }) => (
    <div
        style={{
            position: "relative",
            width: width,
            height: height,
            display: "inline-block"
        }}
        data-name="jira-icon"
    >
        <svg
            style={{
                display: "block",
                width: "100%",
                height: "100%"
            }}
            fill="none"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 24 24"
            data-icon
        >
            <g id="jira-1">
                <path d={svgPaths.p38877400} fill="#2684FF" id="background" />
                <path d={svgPaths.p279c8b00} fill="url(#paint0_linear_jira)" id="top-shape" />
                <path d={svgPaths.p391f0080} fill="url(#paint1_linear_jira)" id="bottom-shape" />
            </g>
            <defs>
                <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_jira" x1="2813.3" x2="1700.08" y1="12.8454" y2="1313.81">
                    <stop offset="0.18" stopColor="#0052CC" />
                    <stop offset="1" stopColor="#2684FF" />
                </linearGradient>
                <linearGradient gradientUnits="userSpaceOnUse" id="paint1_linear_jira" x1="2883.63" x2="1595.92" y1="27.3569" y2="1446.3">
                    <stop offset="0.18" stopColor="#0052CC" />
                    <stop offset="1" stopColor="#2684FF" />
                </linearGradient>
            </defs>
        </svg>
    </div>
);
